import React, { Component } from 'react';
import cn from 'classnames';
import { Label, Input, FormGroup, Row, Col } from 'reactstrap';
import { string, bool, func, array } from 'prop-types';
import CustomControl from '../CustomControl/CustomControl';

class FlowTrackersItem extends Component {
  static propTypes = {
    label: string.isRequired,
    onChange: func.isRequired,
    onCheck: func.isRequired,
    error: string,
    placeholder: string,
    readOnly: bool,
    fields: array.isRequired,
  };

  render() {
    const {
      label,
      name,
      error,
      onChange,
      onCheck,
      className,
      readOnly,
      fields,
      values,
      page,
      type,
    } = this.props;
    const multiple = fields.length > 1;
    const classes = cn(className, { 'has-error': error, multiple });
    const multiLabelClasses = cn({ multiple });
    if (type === 'simple_img') {
      return (
        <FormGroup>
          <CustomControl
            type="checkbox"
            name={`${name}_${page}`}
            onChange={(e) => onCheck(e, page)}
            value="1"
            checked={values && values[`${name}_${page}`] ? !!values[`${name}_${page}`] : false}
            id={`flow-tracker-${name}_${page}`}
            label={label}
          />
        </FormGroup>
      );
    } else {
      return (
        <>
          {multiple && <h6>{label}</h6>}
          <FormGroup className={cn('form-group-upper-label', classes)}>
            {!multiple && (
              <Label for={`flow-tracker-${name}`} className={multiLabelClasses}>
                {label}
              </Label>
            )}
            <Row>
              {fields.map((field) => {
                return (
                  <Col
                    md={fields.length > 1 ? 6 : 12}
                    key={`flow-tracker-${field.fieldName}-${page}`}
                    className='form-group-upper-label'
                  >
                    {multiple && <Label for={`flow-tracker-${name}`} className='flow-tracker-multiple'>{field.title}</Label>}
                    <div
                      className={cn(
                        'field-wrapper',
                        `field-wrapper-${field.name}`,
                        name && `field-wrapper-${name}`,
                        field.fieldName && `field-wrapper-${field.fieldName}`
                      )}
                    >
                      {field.fieldName === 'tracking_13_pixel_id' && (
                        <img
                          className="flow-tracker-field-icon"
                          src="/office/img/metrics/avito-icon.svg"
                          alt=""
                          width={24}
                          height={24}
                        />
                      )}
                      <Input
                        id={`flow-tracker-${field.fieldName}_${page}`}
                        name={field.fieldName}
                        value={values ? values[`${field.fieldName}_${page}`] : ''}
                        onChange={(e) => onChange(e, field.mask, page)}
                        placeholder={field.sample}
                        readOnly={readOnly}
                      />
                    </div>
                  </Col>
                );
              })}
            </Row>
            {error && <small>{error}</small>}
          </FormGroup>
        </>
      );
    }
  }
}

export default FlowTrackersItem;
